var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { notify } from '../../../action';
import { useBoolState } from '../../useHook';
/**
 * スライドの追加処理（複数同時）
 * @param options
 * @returns {{onSubmit: ((function(*, *=): Promise<void>)|*), hideModal: ((function(): void)|*), isShowModal: boolean, showModal: ((function(): void)|*)}}
 */
export const useSlidesAdd = (options) => {
    const { slideSearchSlideUpload } = options;
    const history = useNavigate();
    const { boolState: isShowModal, changeFalse: hideModal, changeTrue: showModal, } = useBoolState(false);
    /**
     * スライド追加処理の実行
     * @type {(function(*, *=): Promise<void>)|*}
     */
    const onSubmit = useCallback((formValues, formDispatch) => __awaiter(void 0, void 0, void 0, function* () {
        const { slides } = formValues;
        yield slideSearchSlideUpload({
            afterCallback: () => {
                history.push('/proffit_search');
                notify('スライドのアップロードを開始しました');
            },
            dispatch: formDispatch,
            slides,
            unmountRef: { current: false },
        });
    }), [history, slideSearchSlideUpload]);
    return {
        hideModal,
        isShowModal,
        onSubmit,
        showModal,
    };
};
export const useMyPageSlideAdd = {
    useSlidesAdd,
};
